import type {GraphDataSerializer} from "@/generated/DjangoTypes";
import type {TCampaignType} from "@/store/types";
import mapKeys from "lodash/mapKeys";
import pickBy from "lodash/pickBy";

const useCharts = (graphs: GraphDataSerializer, type: TCampaignType = "instagram") => {
  const getFilteredGraphs = () => {
    let _graphs = pickBy<GraphDataSerializer>(graphs, (_, key) =>
      type === "tiktok" ? key.includes("tiktok") : !key.includes("tiktok"),
    ) as unknown as GraphDataSerializer;
    return mapKeys(_graphs, (_, key) =>
      type === "tiktok" ? key.replace("tiktok_", "") : key,
    ) as unknown as GraphDataSerializer;
  };

  const temp_graphs = getFilteredGraphs();

  const hasGraphData =
    !!temp_graphs.ages.length &&
    !!temp_graphs.cities.length &&
    !!temp_graphs.countries.length &&
    !!temp_graphs.genders.length;

  const ageChartSum = temp_graphs.ages.reduce((previous, current) => previous + current.value, 0);

  const countriesData = hasGraphData
    ? temp_graphs.countries
    : [
        {label: "Germany", value: 45},
        {label: "Hungary", value: 31},
        {label: "Switzerland", value: 16},
        {label: "Germany", value: 10},
        {label: "Poland", value: 20},
      ];

  const ageData = hasGraphData
    ? temp_graphs.ages.map(ageInformation => ({
        ...ageInformation,
        stackedValue: 100 - ageInformation.value,
        percent: `${((ageInformation.value / ageChartSum) * 100).toFixed(0)}%`,
      }))
    : [
        {
          label: "14-18",
          value: 45,
          stackedValue: 100 - 45,
          percent: "45%",
        },
        {
          label: "18-25",
          value: 31,
          stackedValue: 100 - 31,
          percent: "45%",
        },
        {
          label: "25-35",
          value: 16,
          stackedValue: 100 - 16,
          percent: "45%",
        },
        {
          label: "35+",
          value: 10,
          stackedValue: 100 - 10,
          percent: "45%",
        },
      ];

  const citiesData = hasGraphData
    ? temp_graphs.cities
    : [
        {label: "city", value: 45},
        {label: "city", value: 31},
        {label: "city", value: 16},
        {label: "city", value: 10},
        {label: "city", value: 20},
      ];

  const [menData, womenData] = hasGraphData
    ? [
        temp_graphs.genders.flat().find(element => element.label === "Men" || element.label === "male") ?? {
          label: "Men",
          value: 0,
        },
        temp_graphs.genders.flat().find(element => element.label === "Women" || element.label === "female") ?? {
          label: "Women",
          value: 0,
        },
      ]
    : [
        {
          label: "Men",
          value: 50,
        },
        {
          label: "Women",
          value: 50,
        },
      ];

  return {ageData, countriesData, citiesData, menData, womenData, hasGraphData};
};

export default useCharts;
